'use strict';

module.exports = {
    northAmerica: 'northamerica',
    southAmerica: 'southamerica',
    us: 'us',
    asia: 'asia',
    australia: 'australia',
    europe: 'europe'
};